import React, { useState } from 'react';
import { ArrowUp, ArrowDown } from 'icons';
import color from 'styles/themes/wikifactory/styles/colors';
import { Divisor } from '../Divisor';
import Paragraph from '../Paragraph';
import Heading from '../Heading';
import SvgIcon from '../SvgIcon';
import Box from '../Box';
import { Size } from '../SvgIcon/types';

interface AccordionItemProps {
  title: string;
  subTitle?: string;
  bold?: boolean;
  divisor?: boolean;
  colorLabel?: string;
  innerHighlight?: boolean;
  defaultExpanded?: boolean;
  noExpand?: boolean;
  icon?: React.ReactNode;
  iconSize?: keyof typeof Size;
  content?: string | React.ReactElement;
  button?: React.ReactNode;
  children?: React.ReactNode | React.ReactNode[];
  callBack?: Function;
}

const baseStyles = {
  alignItems: 'center',
  display: 'flex',
};

export const AccordionItem = ({
  icon,
  title,
  subTitle,
  bold,
  divisor,
  colorLabel,
  innerHighlight,
  defaultExpanded,
  noExpand,
  iconSize = Size.medium,
  content,
  button,
  children,
  callBack,
}: AccordionItemProps) => {
  const [isCollapsed, setIsCollapsed] = !defaultExpanded
    ? useState(true)
    : useState(false);

  const handleTitleClick = () => {
    if (!noExpand) {
      setIsCollapsed(prevState => !prevState);
      if (callBack) {
        callBack();
      }
    }
  };

  const headerStyles = {
    ...baseStyles,
    userSelect: 'none',
    cursor: !noExpand && 'pointer',
    ...(colorLabel && { borderLeft: `4px solid ${colorLabel}` }),
  };
  const containerStyles = {
    ...(colorLabel && { borderLeft: `2px solid ${colorLabel}` }),
  };

  return (
    <Box>
      <Box
        mt={1}
        mb={1}
        sx={{
          background: innerHighlight && isCollapsed && color.wfYellow200,
          justifyContent: 'space-between',
          ...baseStyles,
        }}
      >
        <Box sx={{ ...headerStyles }} onClick={handleTitleClick}>
          <SvgIcon icon={icon} size={iconSize} />
          <Heading
            level={6}
            size='default'
            weight={bold ? 'xbold' : 'regular'}
            margin='0 8px 0 8px'
          >
            {title}
          </Heading>
          {subTitle && (
            <Heading
              level={6}
              size='default'
              weight='regular'
              margin='0 8px 0 0px'
            >
              {subTitle}
            </Heading>
          )}
          {!noExpand && (
            <SvgIcon
              icon={isCollapsed ? <ArrowDown /> : <ArrowUp />}
              size='medium'
            />
          )}
        </Box>
        {button && <Box sx={{ display: 'flex' }}>{button}</Box>}
      </Box>
      {!noExpand && !isCollapsed && (
        <Box mt={1} mb={1} sx={{ ...containerStyles }}>
          {content && <Paragraph mb={4}>{content}</Paragraph>}
          {children}
        </Box>
      )}

      {divisor && <Divisor />}
    </Box>
  );
};
